/**
 * The annotation style an expert last chose, reused for every new marker.
 *
 * markerjs starts each marker red and 3 px wide — invisible on a 4000 px
 * photo — so every arrow had to be recoloured and thickened by hand. The width
 * is stored relative to the photo's width, so a stroke chosen on one photo
 * looks the same on the next one whatever its resolution.
 */
const KEY = 'expertisr.annotationStyle';

// Green is in markerjs' palette (so its swatch shows as selected) and reads on
// both dark cellars and pale walls.
export const DEFAULT_STYLE = { color: '#22c55e', widthRatio: 1 / 250 };
const MIN_WIDTH = 3;

export function loadAnnotationStyle() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && typeof saved.color === 'string' && saved.widthRatio > 0) return saved;
  } catch {
    // private mode / corrupted value: fall back to the default
  }
  return DEFAULT_STYLE;
}

export function strokeWidthFor(style, naturalWidth) {
  return Math.max(MIN_WIDTH, Math.round(style.widthRatio * naturalWidth));
}

export function saveAnnotationStyle({ color, width }, naturalWidth) {
  if (!color || !(width > 0) || !(naturalWidth > 0)) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ color, widthRatio: width / naturalWidth }));
  } catch {
    // storage unavailable: the style simply isn't remembered
  }
}
